// services/apiService.js
export const RUTA_SOCKET = process.env.VUE_APP_SOCKET;
// Conexión a WebSocket
export function connectSocket(endpoint) {
    return new WebSocket(`${RUTA_SOCKET}${endpoint}`);
}
